import arrowRight from './arrow-right.svg'
import backArrow from './back-arrow.svg'
import btzHeaderLogo from './bitazza-header-logo.svg'
import emptyResult from './empty_result.svg'
import editIcon from './ic_edit.svg'
import info from './ic_info.svg'
import infoFilled from './ic_info-fiiled.svg'
import navDashboard from './ic_nav_dashboard.svg'
import navDashboardActive from './ic_nav_dashboard_active.svg'
import navMarket from './ic_nav_market.svg'
import navMarketActive from './ic_nav_market_active.svg'
import navTrade from './ic_nav_trade.svg'
import navTradeActive from './ic_nav_trade_active.svg'
import navWallet from './ic_nav_wallet.svg'
import navWalletActive from './ic_nav_wallet_active.svg'
import share from './ic_share.svg'
import navTrophy from './ic_trophy.svg'
import navTrophyActive from './ic_trophy_active.svg'
import trophyIcon from './ic_trophy_white.svg'

import selectedIcon from './ic_selected.svg'
import searchIcon from './ic_search.svg'
import searchNotFound from './ic_searchnotfound.svg'

import fillCheckbox from './fillCheckbox.svg'
import checkbox from './checkbox.svg'
import freedomWallet from './freedomWallet.svg'
import freedomWorld from './fredomWorld.svg'

import FdsToken from './FDS-Token-Coin.svg'

import somethingWentWrong from './somethingWentWrong.svg'

export const SVGs = {
    btzHeaderLogo,
    navDashboard,
    navMarket,
    navTrade,
    navWallet,
    navTrophy,

    navTrophyActive,
    navDashboardActive,
    navMarketActive,
    navTradeActive,
    navWalletActive,

    backArrow,

    arrowRight,
    editIcon,
    trophyIcon,

    info,
    infoFilled,
    emptyResult,
    share,
    selectedIcon,
    searchIcon,
    searchNotFound,

    fillCheckbox,
    checkbox,
    freedomWallet,
    freedomWorld,
    FdsToken,

    somethingWentWrong,
}
